import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ user, onEditProfile, onUpgradeMembership }) => {
  const membershipTiers = {
    free: { name: 'Free Collector', color: 'text-muted-foreground', bgColor: 'bg-muted/20' },
    premium: { name: 'Premium Collector', color: 'text-primary', bgColor: 'bg-primary/10' },
    elite: { name: 'Elite Collector', color: 'text-warning', bgColor: 'bg-warning/10' }
  };

  const currentTier = membershipTiers?.[user?.membershipTier] || membershipTiers?.free;

  return (
    <div className="bg-card border border-border rounded-xl p-6 premium-hover">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Profile Info */}
        <div className="flex items-center space-x-6">
          {/* Avatar */}
          <div className="relative">
            <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-primary/20">
              <Image
                src={user?.avatar}
                alt={user?.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-card flex items-center justify-center">
              <Icon name="Check" size={12} color="white" />
            </div>
          </div>

          {/* User Details */}
          <div className="space-y-2">
            <div className="flex items-center space-x-3">
              <h1 className="text-2xl font-bold text-foreground">{user?.name}</h1>
              <div className={`px-3 py-1 rounded-full text-xs font-medium ${currentTier?.bgColor} ${currentTier?.color}`}>
                {currentTier?.name}
              </div>
            </div>
            <p className="text-muted-foreground">{user?.email}</p>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Calendar" size={16} />
                <span>Joined {user?.joinDate}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="MapPin" size={16} />
                <span>{user?.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            iconName="Edit"
            iconPosition="left"
            onClick={onEditProfile}
          >
            Edit Profile
          </Button>
          {user?.membershipTier === 'free' && (
            <Button
              variant="default"
              iconName="Crown"
              iconPosition="left"
              onClick={onUpgradeMembership}
              className="liquid-gold"
            >
              Upgrade to Premium
            </Button>
          )}
        </div>
      </div>
      {/* Stats Row */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{user?.stats?.totalItems}</div>
          <div className="text-sm text-muted-foreground">Total Items</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">${user?.stats?.portfolioValue?.toLocaleString()}</div>
          <div className="text-sm text-muted-foreground">Portfolio Value</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-success">+{user?.stats?.monthlyGrowth}%</div>
          <div className="text-sm text-muted-foreground">Monthly Growth</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{user?.stats?.achievements}</div>
          <div className="text-sm text-muted-foreground">Achievements</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;